/**
 * Created by tong on 2018/2/1.
 */
import React from 'react';
import {hashHistory} from 'react-router'
import {Button, Table, message, Modal, Row, Col, Input, Icon} from 'antd';
import {DmsTab, DataList, TableView} from 'Components';
import {
    detail, getOrderList, getLinkmanList, getStoreList, getGoodsList, getZhiXiaoList, getCreditList
    , fetchCustomRightChannelList, updateAddress, fetchCustomRightBusinessList
} from '../../service/customerManagement';
/*客户详情展示,订单统计列表,子账户列表,购货单位列表,收货地址列表,信用情况列表*/
import {optionsBtn, optionsRest} from '../../service/customerManagement/linkman';
/*开通账号/禁用账号/修改密码接口*/
import {formatMoney} from 'Utils';
import {openNotice, map} from "../../utils";
import {saveModules, channelLeftSideList, saveModules2, businessLeftSideList} from "../../service/people";


//const data =this.data;
/*const data=  [{
    key: '1',
    name: 'John Brown',
    age: 32,
    address: 'New York No. 1 Lake Park',
}, {
    key: '2',
    name: 'Joe Black',
    age: 42,
    address: 'London No. 1 Lake Park',
}, {
    key: '3',
    name: 'Jim Green',
    age: 32,
    address: 'Sidney No. 1 Lake Park',
}, {
    key: '4',
    name: 'Jim Red',
    age: 32,
    address: 'London No. 2 Lake Park',
}];*/
class customerManagementDetail extends React.Component {
    constructor(props) {
        super(props);
        this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';

        this.state = {
            userData: JSON.parse(window.localStorage.getItem('login_user_information') || '{}'),
            customerManagementId: this.props.params.customerManagementId,
            thirdId: 0,
            empId: 0,
            detail: {},
            orders: [],
            linkmans: [],
            stores: [],
            orderTotal: 0,
            linkmanTotal: 0,
            storeTotal: 0,
            rows: [],
            total: 0,
            //新加自定义筛选菜单
            filterDropdownVisible: false,

            detailAddress: [],
            searchText: '',
            filtered: false,
            searchObj: {
                s: 10,
                p: 1,
                cusId: '',
                data: [],
            },
            LinkmanObj: {
                s: 10,
                p: 1,
                id: this.props.routeParams.customerManagementId
            },
            /*信用情况*/
            staffs: [],
            staffTotal: 0,
            staffObj: {
                s: 10,
                p: 1,
                customerId: '',
                channelCode: this.channelData.split('|')[1] || '',
            },
            /*直销授信*/
            zhiXiao: [],
            zhiXiaoTotal: 0,
            zhiXiaoObj: {
                s: 10,
                p: 1,
                // customerId: props.params.customerManagementId,
                channelCode: this.channelData.split('|')[1] || '',
            },
            visible3: false,
            //弹框用
            visible2: false,
            // 是否展示分销渠道Modal，为了不影响测试，先永久置为false
            visible: false,
            badge: 3,
            // 客戶未添加的列表
            ds1: [],
            ds2: [],
            sendDS2: [], // 保存时用到的，只存id

            ds3: [],
            ds4: [],
            sendDS3: [], // 保存时用到的，只存id
            button_limits_end: {},
        };
        this.getDetail = this.getDetail.bind(this);
        this.getOrders = this.getOrders.bind(this);
        this.getLinkman = this.getLinkman.bind(this);
        this.LinkmanPageChange = this.LinkmanPageChange.bind(this);
        this.getStores = this.getStores.bind(this);
        this.getGoods = this.getGoods.bind(this);
        this.pageChange = this.pageChange.bind(this);
        this.getCredits = this.getCredits.bind(this);
        this.staffPageChange = this.staffPageChange.bind(this);
        this.zhiXiaoChange = this.zhiXiaoChange.bind(this);

        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleOk2 = this.handleOk2.bind(this);
        this.handleCancel2 = this.handleCancel2.bind(this);
        this.handleOk3 = this.handleOk3.bind(this);
        this.handleCancel3 = this.handleCancel3.bind(this);

        this.onInputChange = this.onInputChange.bind(this);
        this.onSearch = this.onSearch.bind(this);
    };

    componentWillMount() {
        // console.log(this.state.userData);
        // if ( ) {

        // }

    }

    componentDidMount() {
        this.setState({
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end"))
        });
        this.getDetail();
        this.getLinkman();
        this.getLeftSideModules();
        this.getCredits();

    };

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };

    /*返回*/
    goBack() {
        hashHistory.goBack();
    };

    /*客户详情展示*/
    getDetail() {
        const self = this;
        let id = this.props.params.customerManagementId;
        detail(id).then(res => {
            self.setState({
                    detail: res.data,
                    searchObj: {...this.state.searchObj, cusId: res.data.thirdId},
                    staffObj: {...this.state.staffObj, customerId: res.data.thirdId},
                },
                () => {
                    self.getGoods();
                    self.getStores(this.state.detail);
                    self.getOrders(this.state.detail);
                    self.getCredits(this.state.staffObj);
                    self.getZhiXiao();
                },
            );
            window.sessionStorage.setItem('customer_detail', JSON.stringify(res.data));
        })
    };

    /*订单统计列表*/
    getOrders(det) {
        const self = this;
        const userId = det.userId
        getOrderList(userId).then(res => {
            self.setState({
                orders: res.data,
                orderTotal: res.total
            })
        });
    };

    toRight = (e) => {
        if (this.state.ds2.length < 9) {
            this.setState({
                ds1: this.state.ds1.filter((_, i) => _.code !== e.code),
                ds2: [...this.state.ds2, e],
                sendDS2: [...this.state.sendDS2, e.code]
            });
        }
    }

    toLeft = (e) => {
        this.setState({
            ds2: this.state.ds2.filter((_, i) => _.code !== e.code),
            ds1: [...this.state.ds1, e],
            sendDS2: this.state.sendDS2.filter((_, i) => _ !== e.code)
        });
    }

    toRight3 = (e) => {
        if (this.state.ds4.length < 9) {
            this.setState({
                ds3: this.state.ds3.filter((_, i) => _.code !== e.code),
                ds4: [...this.state.ds4, e],
                sendDS3: [...this.state.sendDS3, e.code]
            });
        }
    }

    toLeft3 = (e) => {
        this.setState({
            ds4: this.state.ds4.filter((_, i) => _.code !== e.code),
            ds3: [...this.state.ds3, e],
            sendDS3: this.state.sendDS3.filter((_, i) => _ !== e.code)
        });
    }

    toRightAll = () => {
    }

    toLeftAll = () => {
    }

    //右边渠道弹框数据
    getRightCustomerChannel = (record) => {
        fetchCustomRightChannelList({empId: record.id}).then(result => {
            if (result && result.code == 200) {
                this.setState({
                    ds2: result.data
                });
            } else {
                openNotice('error', '数据获取失败', (result && result.message) ? result.message : '');
            }
        });
    }

    getRightCustomerBusiness = (record) => {
        fetchCustomRightBusinessList({empId: record.id}).then(result => {
            if (result && result.code == 200) {
                this.setState({
                    ds4: result.data
                });
            } else {
                openNotice('error', '数据获取失败', (result && result.message) ? result.message : '');
            }
        });
    }

    handleOk = () => {
        this.setState({visible: false});
    }

    handleCancel = () => {
        this.setState({visible: false});
    }

    // 保存自定义模块
    handleOk2 = () => {
        this.setState({visible2: false});
    }

    handleOk3 = () => {
        this.setState({visible3: false});
    }

    //弹出框
    handleOk = () => {
        const {rows} = this.state;
        this.setState({
            searchflag: false,
            orgflag: false
        });

        if (this.state.searchflag) {
            for (var j = 0; j < rows.length; j++) {
                rows[j].operation = false;
            }
        }
    }
    // 保存自定义模块
    handleOk2 = () => {
        this.setState({visible2: false});
        saveModules({Itemselector: this.state.sendDS2, empId: this.state.empId}).then(result => {
            if (result && result.code == 200) {
                openNotice('success', '保存成功');
                this.getLinkman()
            } else {
                openNotice('error', '保存失败', (result && result.message) ? result.message : '');
            }

        });
    }

    handleOk3 = () => {
        this.setState({visible3: false});
        saveModules2({Itemselector: this.state.sendDS3, empId: this.state.empId}).then(result => {
            if (result && result.code == 200) {
                openNotice('success', '保存成功');
                this.getLinkman()
            } else {
                openNotice('error', '保存失败', (result && result.message) ? result.message : '');
            }

        });
    }

    handleCancel2 = () => {
        this.setState({visible2: false});
    }

    handleCancel3 = () => {
        this.setState({visible3: false});
    }

    openModulesDialog = (record) => {
        let id = record.id;
        this.setState({
            visible2: true,
            empId: id
        });
        this.getRightCustomerChannel(record);
    }

    openModulesDialog2 = (record) => {
        let id = record.id;
        this.setState({
            visible3: true,
            empId: id
        });
        this.getRightCustomerBusiness(record);
    }

    getLeftSideModules = () => {
        channelLeftSideList().then(result => {
            if (result && result.code == 200) {
                let datas = result.data;
                //let dd = datas.splice(0, 1)
                this.setState({
                    ds1: datas
                });
            } else {
                openNotice('error', '消息数据获取失败', (result && result.message) ? result.message : '');
            }
        });

        businessLeftSideList().then(result => {
            if (result && result.code == 200) {
                let datas = result.data;
                //let dd = datas.splice(0, 1)
                this.setState({
                    ds3: datas
                });
            } else {
                openNotice('error', '消息数据获取失败', (result && result.message) ? result.message : '');
            }
        });
    }


    /*输入框信息改变*/
    onInputChange = (e) => {
        this.setState({searchText: e.target.value});
    };

    /*自定义筛选菜单搜索功能*/
    onSearch = () => {
        const {searchText} = this.state;
        const reg = new RegExp(searchText, 'gi');
        // console.log(this.state.data);
        //console.log(this.state);

        getGoodsList(this.state.searchObj).then(res => {
            const data = res.data;
            console.log(data);
            /*  data.forEach(record=> {
                  record.edit = false;
              });*/
            this.setState({
                filterDropdownVisible: false,
                filtered: !!searchText,
                rows: data.map((record) => {
                    const match = record.detailAddress.match(reg);
                    record.edit = false;
                    if (!match) {
                        return null;
                    } else {
                        return {
                            ...record,
                        };
                    }
                }).filter(record => !!record),
            });
        })
    }

    /*子账户列表*/
    getLinkman() {
        const self = this;
        const {LinkmanObj} = this.state;
        getLinkmanList(LinkmanObj).then(res => {
            self.setState({
                linkmans: res.data,
                linkmanTotal: res.total
            })
        })
    };

    /*子账户列表翻页*/
    LinkmanPageChange(page, pageSize) {
        const self = this;
        this.setState({LinkmanObj: {...this.state.LinkmanObj, s: pageSize, p: page}}, function () {
            self.getLinkman();
        });
    };

    /*开通账号功能*/
    createAccount(ele) {
        const self = this;
        optionsBtn({id: ele.id, name: ele.name, account: ele.account, status: 1}).then(res => {
            message[res.status ? 'success' : 'error'](res.message);
            res.status && self.getLinkman();
        });
    };

    /*子账户禁用账号功能*/
    invalidAccount(ele) {
        const self = this;
        optionsBtn({id: ele.id, name: ele.name, account: ele.account, status: 2}).then(res => {
            message[res.status ? 'success' : 'error'](res.message);
            res.status && self.getLinkman();
        });
    };

    /*子账户重置密码功能*/
    resetPwd(ele) {
        const self = this;
        optionsRest({id: ele.id, name: ele.name, account: ele.account, plainPassword: 'TG123456'}).then(res => {
            if (!res.status) {
                message['error'](res.message);
            } else {
                openNotice('success', '重置成功，新密码为：TG123456');
            }
            res.status && self.getLinkman();
        })
    };

    /*购货单位列表*/
    getStores(ele) {
        const self = this;
        this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
        let StoreObj = {
            s: 10,
            p: 1,
            fatherId: ele.thirdId,
            channelCode: this.channelData.split('|')[1] || '',
        };
        getStoreList(StoreObj).then(res => {
            self.setState({
                stores: res.data,
                storeTotal: res.total
            })
        })
    };

    /*收货地址列表*/
    getGoods() {
        const self = this;
        getGoodsList(this.state.searchObj).then(res => {
            const data = res.data;
            // console.log(data);
            data.forEach(item => {
                item.edit = false;
            });
            self.setState({
                total: res.total,
                rows: data,
            }, function () {
                self.onSearch()
            })
        })
    };

    /*收货地址列表翻页*/
    pageChange(page, pageSize) {
        const self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            self.getGoods();
        });
    }

    /*信用情况接口*/
    getCredits() {
        const self = this;
        // const { staffObj } = this.state;
        getCreditList(self.state.staffObj).then(res => {
            self.setState({
                staffs: res.data.data,
                staffTotal: res.data.total
            })
        })
    };

    /*直销授信接口*/
    getZhiXiao() {
        const self = this;
        const zhiXiaoObj = {...self.state.zhiXiaoObj};
        zhiXiaoObj.customerId = self.state.detail.thirdId;
        getZhiXiaoList(zhiXiaoObj).then(res => {
            if (res && res.status == true) {
                self.setState({
                    zhiXiao: res.data,
                    zhiXiaoTotal: res.total
                })
            }
        })
    };

    /*信用情况翻页*/
    staffPageChange(page, pageSize) {
        const self = this;
        this.setState({staffObj: {...this.state.staffObj, s: pageSize, p: page}}, function () {
            self.getCredits();
        });
    };

    /*指销售信翻页*/
    zhiXiaoChange(page, pageSize) {
        const self = this;
        this.setState({zhiXiaoObj: {...this.state.zhiXiaoObj, s: pageSize, p: page}}, function () {
            self.getZhiXiao();
        });
    };

    editAddress(record) {
        const {rows} = this.state;
        rows.forEach(item => {
            if (item.id === record.id) {
                item.edit = true;
            }
        })
        this.setState({
            rows: this.state.rows
        });
    }

    saveAddress(record) {
        const {rows} = this.state;
        updateAddress(record).then(res => {
            if (res.code === 200) {
                openNotice('success', '修改成功', '');
                rows.forEach(item => {
                    if (item.id === record.id) {
                        item.edit = false;
                    }
                });
                this.setState({
                    rows: this.state.rows
                })
            }
        })
    }

    changeInput(e, record, type) {
        const {rows} = this.state;
        rows.forEach(item => {
            if (item.id === record.id) {
                item[type] = e.target.value;
            }
        });
        this.setState({
            rows: this.state.rows,
        });
    }


    /*数据渲染*/
    render() {
        const self = this;
        const {
            detail, customerManagementId, orders, stores, orderTotal,
            linkmans, linkmanTotal, button_limits_end,
            LinkmanObj, storeTotal, rows, total, searchObj,
            staffs, staffTotal, zhiXiao, zhiXiaoTotal, zhiXiaoObj, staffObj, visible,
            badge, visible2, ds1, ds2, empId, visible3, ds3, ds4
        } = this.state;

        const channelColumns = [{
            title: 'ID',
            dataIndex: 'id',
            key: 'id'
        }, {
            title: '渠道编码',
            dataIndex: 'code',
            key: 'code'
        }, {
            title: '渠道名称',
            dataIndex: 'name',
            key: 'name'
        }, {
            title: '更新时间',
            dataIndex: 'createdDate',
            key: 'createdDate',
            render: (text) => {
                return new Date(text).format('yyyy-MM-dd hh:mm')
            }
        }];

        const itemLayout = {
            padding: '30px 0',
            textAlign: 'center',
            cursor: 'pointer'
        };
        const iconLayout = {
            fontSize: '32px'
        };
        const settingLayout = {
            float: 'right',
            fontSize: '24px',
            margin: '6px 6px 0 0',
            cursor: 'pointer'
        };
        const columns1 = [{
            title: '未选功能',
            dataIndex: 'name',
            key: 'name',
            render: text => <span>{text}</span>
        }, {
            title: '操作',
            key: 'action',
            className: 'alignCenter',
            render: (text, record, index) => <Button onClick={this.toRight.bind(this, record)}>{'>'}</Button>
        }];
        const columns2 = [{
            title: '操作',
            key: 'action',
            className: 'alignCenter',
            render: (text, record, index) => <Button onClick={this.toLeft.bind(this, record)}>{'<'}</Button>
        }, {
            title: '已选功能',
            dataIndex: 'name',
            key: 'name',
            render: text => <span>{text}</span>
        }];

        const columns3 = [{
            title: '未选功能',
            dataIndex: 'name',
            key: 'name',
            render: text => <span>{text}</span>
        }, {
            title: '操作',
            key: 'action',
            className: 'alignCenter',
            render: (text, record, index) => <Button onClick={this.toRight3.bind(this, record)}>{'>'}</Button>
        }];
        const columns4 = [{
            title: '操作',
            key: 'action',
            className: 'alignCenter',
            render: (text, record, index) => <Button onClick={this.toLeft3.bind(this, record)}>{'<'}</Button>
        }, {
            title: '已选功能',
            dataIndex: 'name',
            key: 'name',
            render: text => <span>{text}</span>
        }];
        const cells = {
            code: {
                title: '客户编码'
            },
            cusType: {
                title: '客户类型 '
            },
            channelType: {
                title: '渠道类型'
            },
            areaName: {
                title: '所属片区'
            },
            address: {
                title: '地址',
                render: text => `${detail.regionName || ''}${detail.areaName || ''}${text || ''}`
            },
            saleChannel: {
                title: '收货省市'
            },
            companySeal: {
                title: '公司盖章名称'
            },
            registryKey: {
                title: '注册表标示'
            },
            seller: {
                title: '业务员'
            },
            createdDate: {
                title: '创建时间',
                render: text => text ? new Date(text).format('yyyy-MM-dd hh:mm:ss') : '----'
            },
            lastUpdatedDate: {
                title: '最后更新',
                render: text => text ? new Date(text).format('yyyy-MM-dd hh:mm:ss') : '----'
            },
        };
        const orderProps = {
            rowKey: 'id',
            columns: [
                {
                    title: '订单编号',
                    dataIndex: 'headerId',
                    render: (text, record, index) => {
                        // return <a href={`#/order/${record.id}`}>{text}</a>
                        if (record.orderType == "1") {
                            if (record.orderStatus == '1' || record.orderStatus == '4') {
                                return <a
                                    href={`#/order/${record.id}/conventionalDetail1/${record.code}/${record.orderStatus}`}>{text}</a>;
                            } else {
                                return <a href={`#/order/${record.id}/conventionalDetail/${record.code}`}>{text}</a>;
                            }
                        }
                        if (record.orderType == "2") {
                            if (record.orderStatus == '1' || record.orderStatus == '4') {
                                return <a
                                    href={`#/order/${record.id}/projectDetail1/${record.code}/${record.orderStatus}`}>{text}</a>;
                            } else {
                                return <a href={`#/order/${record.id}/projectDetail/${record.code}`}>{text}</a>;
                            }
                        }
                        if (record.orderType == "3") {
                            if (record.orderStatus == '1' || record.orderStatus == '4') {
                                return <a
                                    href={`#/order/${record.id}/partnersDetail1/${record.code}/${record.orderStatus}`}>{text}</a>;
                            } else {
                                return <a href={`#/order/${record.id}/partnersDetail/${record.code}`}>{text}</a>;
                            }
                        }

                    }
                },
                {
                    title: '购货单位',
                    dataIndex: 'buyCompany'
                },
                {
                    title: '实际收货地址',
                    dataIndex: 'gatherRealityAddress'
                },
                {
                    title: '订单类型',
                    dataIndex: 'orderType',
                    render: (text, record, index) => {
                        if (text === '1') return '常规订单';
                        if (text === '2') return '项目订单';
                        if (text === '3') return '合作伙伴订单';
                        return '';
                    }
                },
                {
                    title: '下单时间',
                    dataIndex: 'createdDate',
                    render: text => text ? new Date(text).format('yyyy-MM-dd hh:mm:ss') : ''
                }, {
                    title: '订单金额(元)',
                    dataIndex: 'amount',
                    render: text => <span style={{color: '#d61518'}}>{'¥' + formatMoney(text)}</span>
                }, {
                    title: '订单状态',
                    dataIndex: 'orderStatus',
                    render: (text, record, index) => {
                        if (text === 1) return '待审核';
                        if (text === 2) return '待发货';
                        if (text === 3) return '待收货';
                        if (text === 4) return '已完成';
                        if (text === 5) return '已取消';
                        if (text === 6) return '暂存';
                        if (text === 7) return '已审核';
                        return '';
                    }
                },
                {
                    title: '要货单号',
                    dataIndex: 'getProCode'
                },
            ],
            dataSource: orders
        };
        const linkmanProps = {
            loading: false,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: linkmanTotal,
                current: LinkmanObj.p,//当前页码
                pageSize: LinkmanObj.s,//当前分页数
                onChange: this.LinkmanPageChange
            },
            columns: [
                {
                    title: '姓名',
                    dataIndex: 'name',
                },
                {
                    title: '性别',
                    dataIndex: 'sex',
                    render: (text, record, index) => {
                        if (text === 0) return '女';
                        if (text === 1) return '男';
                        return '';
                    }
                },
                {
                    title: '手机',
                    dataIndex: 'phone',
                },
                {
                    title: '账户类别',
                    dataIndex: 'roleCode',
                },
                {
                    title: '账号',
                    dataIndex: 'account',
                },
                {
                    title: '渠道权限',
                    width: '10%',
                    dataIndex: 'channelList',
                    render: (text) => {
                        let str = '     ';
                        if (text != null && text.length > 0) {
                            text.forEach(x => {
                                str += x.name + `; `
                            });
                        }
                        return str;
                    }

                },
                {
                    title: '业务线权限',
                    width: '20%',
                    dataIndex: 'businessLines',
                    render: (text) => {
                        let str = '     ';
                        if (text != null && text.length > 0) {
                            text.forEach(x => {
                                str += x.name + `; `
                            });
                        }
                        return str;
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'id',
                    width: '14%',
                    render: (text, record, index) => {
                        // if(this.state.userData.ownEmp == false) {
                        // this.state.userData.childFlag == false ? record.status == 2 ? <span>
                        //   <a onClick={self.createAccount.bind(self, record)}>开通账号</a>&nbsp;&nbsp;&nbsp;
                        //   <a onClick={self.openModulesDialog.bind(self, record)}>设置渠道</a>&nbsp;&nbsp;&nbsp;
                        //   <a onClick={this.goView.bind(this, `/linkman/${customerManagementId}/add/${record.id}`)}>编辑账号</a>&nbsp;&nbsp;&nbsp;
                        // </span> :
                        // : ''}
                        return (<div>
                            {button_limits_end.customerManagement_detail_02 &&
                                <a onClick={self.invalidAccount.bind(self, record)}>禁用账号</a>}&nbsp;&nbsp;&nbsp;
                            {button_limits_end.customerManagement_detail_03 &&
                                <a onClick={self.resetPwd.bind(self, record)}>重置密码</a>}&nbsp;&nbsp;&nbsp;
                            {button_limits_end.customerManagement_detail_04 &&
                                <a onClick={self.openModulesDialog.bind(self, record)}>设置渠道</a>}&nbsp;&nbsp;&nbsp;
                            {button_limits_end.customerManagement_detail_04 &&
                                <a onClick={self.openModulesDialog2.bind(self, record)}>设置业务线</a>}&nbsp;&nbsp;&nbsp;
                            {button_limits_end.customerManagement_detail_05 &&
                                <a onClick={this.goView.bind(this, `/linkman/${customerManagementId}/add/${record.id}`)}>编辑账号</a>}&nbsp;&nbsp;&nbsp;
                        </div>)

                    }

                },
            ],
            rows: linkmans,
        };
        const storeProps = {
            rowKey: 'id',
            columns: [
                {
                    title: 'ID',
                    dataIndex: 'id'
                },
                {
                    title: '编号',
                    dataIndex: 'code'
                },
                {
                    title: '购货单位',
                    dataIndex: 'name',
                    render: (text, record, index) => {
                        return <a href={`#/purchaseUnit/${record.id}`}>{text}</a>
                    }
                }, {
                    title: '订单类型',
                    dataIndex: 'channelName'
                }, {
                    title: '付款条件',
                    dataIndex: 'payment',
                }
            ],
            dataSource: stores
        };
        const tableViewProps = {
                loading: false,//更新表格数据中
                rowKey: 'id',
                pageParam: {
                    total,
                    current: searchObj.p,//当前页码
                    pageSize: searchObj.s,//当前分页数
                    onChange: this.pageChange
                },
                columns: [
                    {
                        title: '收货人',
                        dataIndex: 'recipientName',
                        width: 200,
                        render: (text, record) => (record.edit ?
                            <Input value={text} onChange={(e) => {
                                this.changeInput(e, record, 'recipientName')
                            }}/> : text)
                    },
                    {
                        title: '购货单位',
                        dataIndex: 'purchaseName',
                    },
                    {
                        title: '所在地区',
                        dataIndex: 'province',
                    },
                    {
                        title: '详细地址',
                        dataIndex: 'detailAddress',
                        key: 'detailAddress',
                        filterDropdown: (
                            <div className="custom-filter-dropdown">
                                <Input
                                    ref={ele => this.searchInput = ele}
                                    placeholder="输入地址"
                                    value={this.state.searchText}
                                    onChange={this.onInputChange}
                                    onPressEnter={this.onSearch}
                                />
                                <Button type="primary" onClick={this.onSearch}>查询</Button>
                            </div>
                        ),
                        filterIcon: <Icon type="search" style={{color: this.state.filtered ? '#108ee9' : '#aaa'}}/>,
                        filterDropdownVisible: this.state.filterDropdownVisible,
                        onFilterDropdownVisibleChange: (visible) => {
                            this.setState({
                                filterDropdownVisible: visible,
                            }, () => this.searchInput.focus());
                        },

                    },


                    {
                        title: '电话',
                        dataIndex: 'mobile',
                        width: 200,
                        render: (text, record) => (record.edit ?
                            <Input value={text} onChange={(e) => {
                                this.changeInput(e, record, 'mobile')
                            }}/> : text)
                    },
                    // {
                    //     title: '操作',
                    //     render: (text, record, index) => {
                    //         // debugger
                    //         // console.log(record.edit);
                    //         // console.log(button_limits_end.customerManagement_detail_06);
                    //         if (record.edit) {
                    //             return <div>
                    //                 <Button
                    //                     onClick={() => {
                    //                         this.saveAddress(record)
                    //                     }}
                    //                     style={{display: button_limits_end.customerManagement_detail_06 == true ? 'block' : 'none'}}
                    //                 >保存
                    //                 </Button></div>
                    //         }
                    //         return <div>
                    //             <Button
                    //                 onClick={() => {
                    //                     this.editAddress(record)
                    //                 }}
                    //                 style={{display: button_limits_end.customerManagement_detail_07 == true ? 'block' : 'none'}}
                    //             >修改</Button>
                    //         </div>
                    //     }
                    // }
                ],
                rows,
                // return <Table columns={columns} dataSource={this.state.data} />;


            }
        ;
        const staffProps = {
            loading: false,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: staffTotal,
                current: staffObj.p,//当前页码
                pageSize: staffObj.s,//当前分页数
                onChange: this.staffPageChange
            },
            columns: [
                {
                    title: '授信方式',
                    dataIndex: 'pay',
                },
                {
                    title: '渠道',
                    dataIndex: 'channelName',
                },
                {
                    title: '授信项目或购货单位',
                    dataIndex: 'projectName',
                },
                {
                    title: '授信额度',
                    dataIndex: 'sxeAmount',
                },
                {
                    title: '折扣池余额',
                    dataIndex: 'discountAmount',
                },
                {
                    title: '已用额度',
                    dataIndex: 'yyAmount',
                },
                {
                    title: '可用额度',
                    dataIndex: 'kyAmount',
                },

            ],
            rows: staffs,
        };
        const zhixiaoProps = {
            loading: false,//更新表格数据中
            rowKey: 'lineId',
            pageParam: {
                total: zhiXiaoTotal,
                current: zhiXiaoObj.p,//当前页码
                pageSize: zhiXiaoObj.s,//当前分页数
                onChange: this.zhiXiaoChange
            },
            columns: [
                // {
                //   title: '授信方式',
                //   dataIndex: 'pay',
                // },
                {
                    title: '变动日期',
                    dataIndex: 'creationDate',
                    render: (text) => text ? new Date(text).format('yyyy-MM-dd') : ''
                },
                {
                    title: '项目编号',
                    dataIndex: 'projectNumber',
                },
                {
                    title: '项目名称',
                    dataIndex: 'projectName',
                },

                {
                    title: '购货单位',
                    dataIndex: 'purchaseName',
                },
                {
                    title: '可用余额',
                    dataIndex: 'kyAmount',
                },
                {
                    title: '是否折扣',
                    dataIndex: 'descountFlag',
                    render: (text) => text == 'Y' ? <div>{'是'}</div> : <div>{'否'}</div>
                },
                {
                    title: '质保金',
                    dataIndex: 'zbjMoney',
                },
                {
                    title: '质保金到期时间',
                    dataIndex: 'zbjDate',
                },
                {
                    title: '开始时间',
                    dataIndex: 'startDate',
                    render: (text) => text ? new Date(text).format('yyyy-MM-dd') : ''
                },
                {
                    title: '结束时间',
                    dataIndex: 'endDate',
                    render: (text) => text ? new Date(text).format('yyyy-MM-dd') : ''
                },

            ],
            rows: zhiXiao,
        };
        //return <Table columns={columns} dataSource={this.state.data} />;
        return <div className="dms-main-box">
            <div>
                <DmsTab options={[`客户详情 -- ${detail.name || ''}`]} defaultKey={0}>
                    <Button onClick={this.goBack}>返回</Button>
                </DmsTab>
                <div className="dms-table-box">
                    <DataList cells={cells} data={detail}></DataList>
                </div>
            </div>
            <div>
                <DmsTab className="white-bg no-border" options={['订单统计']} defaultKey={0}/>
                <div className="dms-table-box">
                    <Table {...orderProps} bordered pagination={false}/>
                    <br/>
                    {!!orderTotal &&
                        <p><a
                            onClick={this.goView.bind(this, `/order?customerManagementId=${customerManagementId}`)}>查看全部（{orderTotal}）</a>
                        </p>
                    }
                </div>
            </div>
            <div className="dms-split-bar"></div>
            <div>
                <DmsTab className="white-bg no-border" options={['子账户']} defaultKey={0}>
                    {button_limits_end.customerManagement_detail_01 && <Button type="primary"
                        // style={{display: this.state.userData.childFlag == true &&  ? 'none' : 'block'}}
                                                                               onClick={this.goView.bind(this, `/linkman/${customerManagementId}/add/0`)}>新增子账号</Button>}
                </DmsTab>
                <div className="dms-table-box">
                    <TableView {...linkmanProps} />
                </div>
            </div>
            <div className="dms-split-bar"></div>
            <div>
                <DmsTab className="white-bg no-border" options={['购货单位']} defaultKey={0}></DmsTab>
                <div className="dms-table-box">
                    <Table {...storeProps} bordered pagination={false}/>
                    <br/>
                    {!!storeTotal &&
                        <p><a
                            onClick={this.goView.bind(this, `/purchaseUnit?fatherCode=${customerManagementId}`)}>查看全部（{storeTotal}）</a>
                        </p>
                    }
                </div>
            </div>
            <div className="dms-split-bar"></div>
            <div>
                <DmsTab className="white-bg no-border" options={['收货地址']} defaultKey={0}>
                </DmsTab>
                <div className="dms-table-box">
                    <TableView {...tableViewProps} />
                </div>
            </div>
            <div className="dms-split-bar"></div>
            <div>
                <DmsTab className="white-bg no-border" options={['滚动授信情况']} defaultKey={0}></DmsTab>
                <div className="dms-table-box">
                    <TableView {...staffProps} />
                </div>
                <Modal
                    visible={visible2}
                    title="请选择要添加的渠道"
                    onOk={this.handleOk2}
                    onCancel={this.handleCancel2}
                    maskClosable={false}>
                    <div>
                        <Row gutter={16}>
                            <Col span={10}>
                                <Table
                                    /*rowSelection={rowSelection1}
                                     selectWay="onSelect"*/
                                    columns={columns1}
                                    dataSource={ds1}
                                    pagination={false}
                                    rowKey="id"
                                    bordered
                                />
                            </Col>
                            <Col span={4} style={{position: 'absolute', top: '50%', left: '42%'}}>
                                <Row type="flex" justify="center">
                                    <Col>
                                        <Button onClick={this.toRightAll}
                                                disabled={this.state.disableRightAll}>{'>>'}</Button>
                                    </Col>
                                    <Col style={{marginTop: 10}}>
                                        <Button disabled={true}>{'<<'}</Button>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={10} style={{float: 'right'}}>
                                <Table
                                    /*rowSelection={rowSelection2}*/
                                    columns={columns2}
                                    dataSource={ds2}
                                    pagination={false}
                                    rowKey="id"
                                    bordered
                                />
                            </Col>
                        </Row>
                    </div>
                </Modal>

                <Modal
                    visible={visible3}
                    title="请选择要添加的业务线"
                    onOk={this.handleOk3}
                    onCancel={this.handleCancel3}
                    maskClosable={false}>
                    <div>
                        <Row gutter={16}>
                            <Col span={10}>
                                <Table
                                    /*rowSelection={rowSelection1}
                                     selectWay="onSelect"*/
                                    columns={columns3}
                                    dataSource={ds3}
                                    pagination={false}
                                    rowKey="id"
                                    bordered
                                />
                            </Col>
                            <Col span={4} style={{position: 'absolute', top: '50%', left: '42%'}}>
                                <Row type="flex" justify="center">
                                    <Col>
                                        <Button onClick={this.toRightAll}
                                                disabled={this.state.disableRightAll}>{'>>'}</Button>
                                    </Col>
                                    <Col style={{marginTop: 10}}>
                                        <Button disabled={true}>{'<<'}</Button>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={10} style={{float: 'right'}}>
                                <Table
                                    /*rowSelection={rowSelection2}*/
                                    columns={columns4}
                                    dataSource={ds4}
                                    pagination={false}
                                    rowKey="id"
                                    bordered
                                />
                            </Col>
                        </Row>
                    </div>
                </Modal>
            </div>
            <div>
                <DmsTab className="white-bg no-border" options={['直销授信']} defaultKey={0}>
                </DmsTab>
                <div className="dms-table-box">
                    <TableView {...zhixiaoProps} />
                </div>
            </div>
        </div>
    }
}

export default customerManagementDetail;



// WEBPACK FOOTER //
// ./src/routes/customerManagement/detail.js